import locales from '@/system/config/_locales';
export default locales;
